var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg018Apron = function Svg018Apron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M211 271h90v60h-90z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M482 391v-90c0-33.091-26.909-60-60-60h-36.374C376.983 221.704 361 178.973 361 127.925V60h-30V0h-30v60h-90V0h-30v60h-30v67.925c0 52.729-15.784 94.254-24.459 113.075H90c-33.091 0-60 26.909-60 60v90c0 16.538-13.462 30-30 30v30c33.091 0 60-26.909 60-60v-90c0-16.538 13.462-30 30-30h31v241h270V271h31c16.538 0 30 13.462 30 30v90c0 33.091 26.909 60 60 60v-30c-16.538 0-30-13.462-30-30m-151-30H181V241h150z"
  })));
};
export default Svg018Apron;